import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[psUiToNumber]',
})
export class ToNumberDirective {
  constructor(private _element: ElementRef, public model: NgControl) {}

  @HostListener('change', ['$event'])
  onEvent() {
    let { value } = this._element.nativeElement;
    if (value) {
      value = Number(value);
      if (this.model.control) {
        this.model.control?.setValue(value);
      }
      return value;
    }
    return value;
  }
}
